// extracted by mini-css-extract-plugin
export default {"like_panel_container":"LikePanel_like_panel_container__nX0vw"};